import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { t } from "../lib/i18n";

export default function ProtectedRoute({
  children,
  role,
  allowWithoutNDA = false,
  allowWithoutInvestorTerms = false,
  allowWithoutSearcherProfile = false,
}) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <span className="font-mono-label text-muted-foreground">{t("Cargando…")}</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!user.role) return <Navigate to="/role-select" replace />;
  if (role && user.role !== role) {
    if (user.role === "seller") return <Navigate to="/seller/dashboard" replace />;
    if (user.role === "searcher") return <Navigate to="/searcher/marketplace" replace />;
    return <Navigate to="/investor/marketplace" replace />;
  }
  // Seller: NDA gate
  if (
    user.role === "seller" &&
    !user.nda_accepted &&
    !allowWithoutNDA &&
    !location.pathname.startsWith("/seller/confidentiality")
  ) {
    return <Navigate to="/seller/confidentiality" replace />;
  }
  // Searcher: triangulated profile gate
  if (
    user.role === "searcher" &&
    !user.searcher_profile_completed &&
    !allowWithoutSearcherProfile &&
    !location.pathname.startsWith("/searcher/onboarding")
  ) {
    return <Navigate to="/searcher/onboarding" replace />;
  }
  // Investor: terms + profile gate
  if (
    user.role === "investor" &&
    !user.investor_terms_accepted &&
    !allowWithoutInvestorTerms &&
    !location.pathname.startsWith("/investor/onboarding")
  ) {
    return <Navigate to="/investor/onboarding" replace />;
  }
  return children;
}
